import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "Component", "formControlUse", "dataTestId", "label", "hoverContent", "onDetailsClick"];
import { READ_ONLY } from 'customer-data-objects/property/AccessLevel';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { useGetDefaultHoverContent } from '../../hooks/useGetDefaultHoverContent';
import { useGetIsUngated } from '../hooks/useGetIsUngated';
import { useProperty } from '../hooks/useProperty';
import { usePropertyAccessLevel } from '../hooks/usePropertyAccessLevel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getLabel = property => {
  return property.hubspotDefined ? propertyLabelTranslator(property.label) : property.label;
};
const getLabelTooltip = accessLevel => {
  if (accessLevel === READ_ONLY) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.formControl.flpReadOnlyTooltip"
    });
  }
  return undefined;
};
const PropertyInputFormControl = _ref => {
  let {
      children,
      Component = FormControl,
      formControlUse = 'default',
      dataTestId: dataTestIdProp,
      label,
      hoverContent,
      onDetailsClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const property = useProperty();
  const accessLevel = usePropertyAccessLevel();
  const getIsUngated = useGetIsUngated();
  const isDisplayOptimized = formControlUse === 'floating' || rest.displayOptimized;
  const defaultHoverContent = useGetDefaultHoverContent({
    onDetailsClick,
    displayOptimized: isDisplayOptimized
  });
  if (formControlUse === 'inline' || formControlUse === 'table-cell' || !Component) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const hasLabelGate = getIsUngated('CRM:Properties:DefaultLabel');
  const defaultLabel = hasLabelGate ? getLabel(property) : undefined;
  const resolvedLabel = label === undefined ? defaultLabel : label;
  const resolvedDataTestId = dataTestIdProp !== null && dataTestIdProp !== void 0 ? dataTestIdProp : isDisplayOptimized ? 'DisplayOptimizedFormControl' : 'FormControl';
  const resolvedHoverContent = hoverContent === undefined ? defaultHoverContent : hoverContent;
  const commonProps = Object.assign({
    label: resolvedLabel,
    hoverContent: resolvedHoverContent,
    'data-test-id': resolvedDataTestId,
    labelTooltip: getLabelTooltip(accessLevel)
  }, rest);
  if (isDisplayOptimized) {
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      displayOptimized: true
    }, commonProps, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Component, Object.assign({}, commonProps, {
    children: children
  }));
};
export default PropertyInputFormControl;